import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { TableCell } from '@helsenorge/designsystem-react/components/Table';
import styles from '../table/styles.module.scss';
export class Cell extends React.Component {
    highlightText(text, highlight) {
        const highlightStartIndex = text.toLowerCase().indexOf(highlight.toLowerCase());
        if (highlightStartIndex >= 0) {
            const highlightEndIndex = highlightStartIndex + highlight.length;
            const textStart = text.substr(0, highlightStartIndex);
            const textHighlight = text.substr(highlightStartIndex, highlight.length);
            const textEnd = text.substr(highlightEndIndex);
            return (_jsxs("span", { children: [textStart, _jsx("span", { className: styles['table__highlight-text'], children: textHighlight }), textEnd] }));
        }
        return text;
    }
    highlightContent(children, highlightText) {
        const highlightedContent = React.Children.map(children, (child) => {
            if (typeof child === 'string') {
                return this.highlightText(child.toString(), highlightText);
            }
            if (child) {
                const childProps = child.props;
                if (childProps && childProps.children) {
                    const highlightedChildren = this.highlightContent(childProps.children, highlightText);
                    return Object.assign({}, child, { props: Object.assign({}, childProps, { children: highlightedChildren }) });
                }
            }
            return child;
        });
        return highlightedContent;
    }
    render() {
        const { children, highlightText, columnKey } = this.props;
        const content = highlightText ? this.highlightContent(children, highlightText) : children;
        return (_jsx(TableCell, { dataLabel: columnKey || '', textAlign: this.props.textAlign, children: content }));
    }
}
